<mat-toolbar class="subtitulo">RIM</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultarRim="ngForm">
            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboUnidade" fxFlex="100">
                    <combo-unidade [showDisplayId]="false"
                                   [obrigatorio]="false"
                                   [selecionado]="unidadeSelecionada"
                                   (valorChange)="onValorChangeUnidade($event)">
                    </combo-unidade>
                </div>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="20">
                    <mat-label>Data Início</mat-label>
                    <input matInput name="dataInicio" [matDatepicker]="dataInicioPicker" placeholder="Data Início"
                           [(ngModel)]="dataInicio" (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="20">
                    <mat-label>Data Fim</mat-label>
                    <input matInput name="dataFim" [matDatepicker]="dataFimPicker" placeholder="Data Fim"
                           [(ngModel)]="dataFim" (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboContrato" fxFlex="100">
                    <combo-contrato [showDisplayId]="false"
                                    [obrigatorio]="false"
                                    [selecionado]="contratoSelecionado"
                                    (valorChange)="onValorChangeContrato($event)">
                    </combo-contrato>
                </div>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                 fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="modeloPadrao">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon>{{ element.modeloPadrao ? 'star' : '' }}</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="unidade">
                <th mat-header-cell *matHeaderCellDef> Unidade</th>
                <td mat-cell *matCellDef="let element"> {{ element.unidade?.nomeUnidade }}</td>
            </ng-container>
            <ng-container matColumnDef="contrato">
                <th mat-header-cell *matHeaderCellDef style="width: 40%"> Contrato</th>
                <td mat-cell *matCellDef="let element"> {{ element.contrato?.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="dataInicio">
                <th mat-header-cell *matHeaderCellDef> Data Inicio</th>
                <td mat-cell *matCellDef="let element"> {{ element.dataInicio | dataSimples }}</td>
            </ng-container>
            <ng-container matColumnDef="dataFim">
                <th mat-header-cell *matHeaderCellDef> Data Fim</th>
                <td mat-cell *matCellDef="let element"> {{ element.dataFim | dataSimples }}</td>
            </ng-container>
            <ng-container matColumnDef="finalizado">
                <th mat-header-cell *matHeaderCellDef> Situação</th>
                <td mat-cell *matCellDef="let element"> {{ element.finalizado ? 'Finalizado' : 'Em Andamento' }}</td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; padding-right: 0px;">Ações</th>
                <td mat-cell *matCellDef="let element" style="text-align: center; padding-right: 0px;">
                    <button mat-button [matMenuTriggerFor]="acaoPesquisa">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #acaoPesquisa="matMenu">
                        <button *ngIf="perfilAcesso.consulta" mat-menu-item (click)="abrirOpcoesRelatorio(element.id)">
                            <mat-icon>print</mat-icon>
                            Gerar Relatório
                        </button>
                        <button *ngIf="perfilAcesso.altera && !element.finalizado" mat-menu-item
                                (click)="finalizar(element)">
                            <mat-icon>check</mat-icon>
                            Finalizar
                        </button>
                        <button *ngIf="perfilAcesso.consulta" mat-menu-item (click)="atualizar(element)">
                            <mat-icon>{{ perfilAcesso.altera && !element.finalizado ? 'create' : 'search' }}</mat-icon>
                            {{ perfilAcesso.altera && !element.finalizado ? 'Alterar' : 'Visualizar' }}
                        </button>
                        <button *ngIf="perfilAcesso.insere" mat-menu-item (click)="duplicarRim(element)">
                            <mat-icon>restore_page</mat-icon>
                            Duplicar
                        </button>
                        <button *ngIf="perfilAcesso.altera && !element.modeloPadrao" mat-menu-item
                                (click)="alterarModeloPadrao(element)"
                                [disabled]="element.modeloPadrao">
                            <mat-icon>star</mat-icon>
                            Marcar Modelo Padrão
                        </button>
                        <button *ngIf="perfilAcesso.deleta && !element.finalizado" mat-menu-item (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                            Excluir
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{ msg }}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
             style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar" mat-fab color="primary" (click)="irParaCadastro()"
                        routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>